export default __webpack_public_path__ + "529b4e537eaadaaf88b48663a6012c48.svg";